import { AfterContentChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NzNotificationService } from 'ng-zorro-antd';
import { TITLE } from 'src/app/utils/enum';
import { FormFieldInfo } from '../../../../models/forms-response.models';

@Component({
    selector: 'app-component-date-checkbox',
    templateUrl: './date-checkbox.component.html',
    styleUrls: ['./date-checkbox.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DateCheckboxComponent implements OnInit, OnChanges, AfterContentChecked {
    @Input() formFieldInfo: FormFieldInfo;
    @Input() formGroup: FormGroup;
    @Input() formData: any;
    @Input() modalTitle:any;

    formFieldConfig: any;
    fieldConfig: any;
    isRequired: boolean;
    name: string;
    hideTitle: boolean;
    checked: boolean;
    value: string;
    isError: string;
    fieldCode: string;
    tooltip: string;
    fieldDataInfo:any;
    taxCode="";
    formCode="";

    constructor(private nzModalNotification: NzNotificationService, private cdref: ChangeDetectorRef) { }

    ngOnChanges() {
        if (this.formData && this.formData[this.fieldCode]) {
            this.value = this.formData[this.fieldCode];
        }
    }

    ngOnInit(): void {
        this.formFieldConfig = this.formFieldInfo.formFieldConfig ? JSON.parse(this.formFieldInfo.formFieldConfig) : "";
        this.fieldConfig = this.formFieldInfo.fieldConfig ? JSON.parse(this.formFieldInfo.fieldConfig) : "";
        this.fieldCode = this.formFieldInfo.fieldCode;
        this.fieldDataInfo=this.formFieldInfo;
        this.hideTitle = (this.formFieldConfig && this.formFieldConfig.hideTitle) ? this.formFieldConfig.hideTitle : false;
        this.name = (this.formFieldConfig && this.formFieldConfig.displayText) ? this.formFieldConfig.displayText : this.formFieldInfo.name;

        this.hideTitle = (this.formFieldConfig && this.formFieldConfig.hideTitle) ? this.formFieldConfig.hideTitle : false;
        this.tooltip = this.formFieldConfig && this.formFieldConfig.tooltip ? this.formFieldConfig.tooltip : "";
        this.formCode=localStorage.getItem('FORM_CODE');
        this.taxCode=localStorage.getItem('TAXCODE');
        this.bindingData();
    }

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    onChangeDateCheckBox() {

    }

    modelChange() {
        localStorage.setItem("VALUE_" + this.formFieldInfo.formCode +'_'+ this.taxCode+ '_'+ this.fieldCode, this.value);
        localStorage.setItem("VALUE_CHECKBOX_" + this.formFieldInfo.formCode +'_'+ this.taxCode+ '_'+ this.fieldCode, this.checked ? "true" : "false");
    }
    bindingData(){
        if (this.modalTitle == TITLE.ADD_DATA)//This case is: Click icon(+) to open popup
        {
            this.checked = localStorage.getItem("VALUE_CHECKBOX_" +this.formFieldInfo.formCode +'_'+ this.taxCode + '_'+ this.fieldCode) == "true" ? true : false;
        }
        else if (this.modalTitle == TITLE.UPDATE_DATA) { //This case is: Click icon(edit) to open popup
            if (this.formData) {
                let objectData = this.formData;
                const keys = Object.keys(objectData);
                keys.forEach((key) => {
                    if (key == this.formFieldInfo.fieldCode) {
                        let value = objectData[key];
                        this.value = value;
                        this.checked = localStorage.getItem("VALUE_CHECKBOX_" + this.formFieldInfo.formCode +'_'+ this.taxCode + '_'+ key) == "true" ? true : false;
                    }
                });
            }
        }
        else {
            let storageVal = localStorage.getItem("VALUE_" + this.formFieldInfo.formCode +'_'+ this.taxCode+ '_'+ this.fieldCode);
            this.checked = localStorage.getItem("VALUE_CHECKBOX_" + this.formFieldInfo.formCode +'_'+ this.taxCode + '_'+ this.fieldCode) == "true" ? true : false;
            if (storageVal) {
                this.value = storageVal ? storageVal : '';
            } else if (this.formData && this.formData[this.fieldCode]) {
                this.value = this.formData[this.fieldCode];
            } else {
                this.value = (this.formFieldConfig && this.formFieldInfo.defaultValue) ? this.formFieldInfo.defaultValue : '';
            }
        }
    }
}